import {
  HMSPeer,
  selectIsPeerAudioEnabled,
  selectPeerAudioByID,
  selectPeerMetadata,
  useHMSStore,
  useVideo,
} from "@100mslive/react-sdk";
import { observer } from "mobx-react";
import { useEffect, useState, memo } from "react";
import { Child } from "../../api/child";
import { globalStores } from "../../api/globalStores";
import noVideo from "../../assets/no-video.png";
import IconMic from "../../Common/Icons/IconMic";
import IconMicStop from "../../Common/Icons/IconMicStop";
import {
  EngagementPanelResultString,
  HMSTalkingPartyPeerMetadata,
} from "../../Common/Utility/helpers";
import EnlargeLogo from "../../assets/EnlargeLogo.png";

const logger = console;
const childCache = new Map<number, Child>();

interface StudentVideoCardProps {
  participant: HMSPeer;
  onMouseEnter: (trackID?: string, name?: string) => void;
  onMouseLeave: () => void;
}

export const StudentVideoCard = observer((props: StudentVideoCardProps) => {
  if (!props.participant.customerUserId) {
    throw new Error("Customer user id must be defined!");
  }

  const userIdentity = JSON.parse(props.participant.customerUserId) as {
    teacherId: number | null;
    studentId: number | null;
  };

  // const [correctnessEmoji, setCorrectednessEmoji] = useState("");
  // const [selectedAns, setSelectedAns] = useState("");
  const [child, setChild] = useState<Child>();
  // const [statusUpdates, setStatusUpdates] = useState(0);
  // const [emotion, setEmotion] = useState<string | undefined>();
  // const [status, _setStatus] = useState<string | undefined>();
  useEffect(() => {
    (async () => {
      if (!userIdentity.studentId) {
        return;
      }
      const cached = childCache.get(userIdentity.studentId);
      if (cached) {
        setChild(cached);
        return;
      }
      const newChild = new Child();
      await newChild.init(userIdentity.studentId);
      childCache.set(userIdentity.studentId, newChild);
      setChild(newChild);
    })();
  }, [userIdentity.studentId]);

  // const setStatus = (newStatus: string | undefined, newEmotion?: string) => {
  //   if (newStatus !== undefined) {
  //     liveStatus.current = newStatus;
  //   }
  //   if (newEmotion) {
  //     setEmotion(newEmotion);
  //   }
  //   if (statusUpdates > 5) {
  //     _setStatus(liveStatus.current);
  //     return;
  //   }

  //   setStatusUpdates(statusUpdates + 1);
  //   const curEmotion = newEmotion ?? emotion ?? "";
  //   if (newStatus !== undefined) {
  //     _setStatus(curEmotion);
  //     return;
  //   }
  //   _setStatus(`${liveStatus.current} ${curEmotion}`);
  // };
  const localPeerMetadata: HMSTalkingPartyPeerMetadata = useHMSStore(
    selectPeerMetadata(props.participant.id)
  );

  const audioEnabled = useHMSStore(
    selectIsPeerAudioEnabled(props.participant.id)
  );

  const peerAudioLevel = useHMSStore(selectPeerAudioByID(props.participant.id));

  const isAudioDegraded = globalStores.curTalkingParty.isTrackDegraded(
    props.participant.audioTrack
  );
  const isVideoDegraded = globalStores.curTalkingParty.isTrackDegraded(
    props.participant.videoTrack
  );

  // useEffect(() => {
  //   console.log({
  //     audioEnabled,
  //     videoEnabled,
  //   });
  // }, [audioEnabled, videoEnabled]);

  // useEffect(() => {
  //   console.log(`Volume of ${props.participant.id}: ${peerAudioLevel}`);
  // }, [peerAudioLevel]);

  // const updateEmotion = () => {
  //   if (!child) return;
  //   if (!child.childAccount.talkingPartyStatus) return;
  //   const currentEmotion =
  //     globalStores.curTalkingParty.talkingPartyStatuses[
  //       child.childAccount.talkingPartyStatus
  //     ]?.howAreYouFeeling;

  //   setEmotion(currentEmotion);
  // };

  // useEffect(() => {
  //   //Temporary fix because the record does not have reactive state
  //   setTimeout(updateEmotion, 500);
  // }, [
  //   globalStores.curTalkingParty.talkingPartyStatuses,
  //   child?.childAccount.talkingPartyStatus,
  //   globalStores.curTalkingParty.talkingPartyStatuses[
  //     child?.childAccount.talkingPartyStatus ?? ""
  //   ]?.howAreYouFeeling,
  // ]);

  // useEffect(() => {
  //   if (!child) return;
  //   if (!child.childAccount.talkingPartyStatus) return;

  //   const newHandRaised =
  //     globalStores.curTalkingParty.talkingPartyStatuses[
  //       child.childAccount.talkingPartyStatus
  //     ]?.handRaised;

  //   if (newHandRaised !== previousHandRaised) {
  //     updateHandRaised(newHandRaised);
  //   }
  // }, [globalStores.curTalkingParty.talkingPartyStatuses]);

  // const updateHandRaised = (newHandRaised: boolean | undefined) => {
  //   setPreviousHandRaised(newHandRaised);
  //   if (newHandRaised) {
  //     setHandRaisedText("✋");
  //   } else {
  //     setHandRaisedText("");
  //   }
  // };

  // useEffect(() => {
  //   setStatus("");
  // }, [globalStores.curEPanel.engagementPanel.id]);

  // useEffect(() => {
  //   if (!child) return;
  //   const studentResult =
  //     globalStores.curTalkingParty.engagementPanelResults.filter((result) => {
  //       if (
  //         result.student === child.childAccount.id &&
  //         result.engagementPanel ===
  //           globalStores.curEPanel.engagementPanel.id &&
  //         result.talkingPartyRoom ===
  //           globalStores.curTalkingParty.talkingParty.id
  //       ) {
  //         return true;
  //       } else {
  //         return false;
  //       }
  //     });
  //   if (studentResult.length === 0) return setSelectedAns("");
  //   if (studentResult.length > 1) {
  //     logger.error("Bad Student Result", studentResult);
  //     logger.error(
  //       "Should only have one engagement panel result for a specific student for a specific party!"
  //     );
  //   }
  //   const selectedAns = studentResult[0].answerSelected;

  //   setSelectedAns(selectedAns ?? "");
  //   // setStatus(`${correctnessEmoji}${selectedAns}`);
  // }, [
  //   child,
  //   globalStores.curTalkingParty.engagementPanelResults,
  //   globalStores.curEPanel.engagementPanel.id,
  //   globalStores.curEPanel.engagementPanel.answer,
  // ]);

  // useEffect(() => {
  //   const selectedAns
  //   const correctnessEmoji =
  //     globalStores.curEPanel.engagementPanel.answer === null
  //       ? ""
  //       : selectedAns === globalStores.curEPanel.engagementPanel.answer
  //       ? "✔️"
  //       : "❌";

  //   setCorrectednessEmoji(correctnessEmoji);
  // }, [selectedAns, globalStores.curEPanel.engagementPanel.answer]);

  const selectedAns: EngagementPanelResultString = globalStores.curEPanel
    .engagementPanel.id
    ? localPeerMetadata?.engagementPanelResults?.[
        globalStores.curEPanel.engagementPanel.id
      ]
    : undefined;

  const correctnessEmoji =
    globalStores.curEPanel.engagementPanel.answer === null || !selectedAns
      ? ""
      : String(selectedAns).trim().toUpperCase() === String(globalStores.curEPanel.engagementPanel.answer).trim().toUpperCase()
      ? "✔️"
      : "❌";

  // const { videoRef } = useVideo({
  //   trackId: props.participant.videoTrack,
  // });

  if (userIdentity.teacherId) return <></>;
  if (!child) return <></>;

  const name =
    child.userDetail.firstName +
    " " +
    child.userDetail.lastName?.charAt(0) +
    ".";

  return (
    <div
      className="relative overflow-clip bg-brij-MudDark rounded-xl w-full h-full flex items-center justify-center"
      //TODO: Add this back in the future.
      // onMouseEnter={() => {
      //   props.onMouseEnter(props.participant.videoTrack, name);
      //   setStudentFeedFocused(true);
      // }}
      // onMouseLeave={() => {
      //   props.onMouseLeave();
      //   setStudentFeedFocused(false);
      // }}
    >
      {/* <AudioTrack track={props.participant ? audioTrack : undefined} /> */}
      {peerAudioLevel > 0 && (
        <div className="bg-brij-Gold absolute -inset-0 rounded-xl animate-pulse transition ease-in-out duration-300 " />
      )}
      {/* {studentFeedFocused && (
        <img
          src={EnlargeLogo}
          alt="EnlargeLogo"
          className="object-contain h-full w-full p-12"
        />
      )}
      {!studentFeedFocused && (
        <Video videoTrack={props.participant.videoTrack} />
      )} */}
      <Video
        videoTrack={props.participant.videoTrack}
        isDegraded={isVideoDegraded}
      />

      <div className="absolute object-cover bottom-1 left-1 py-1 px-2 bg-brij-Black bg-opacity-50 rounded-xl flex items-center gap-2">
        <div className="text-md text-brij-White drop-shadow-xl font-semibold">
          {name}
        </div>
        {isAudioDegraded && audioEnabled && (
          <div className="flex items-center gap-1 bg-brij-Orange bg-opacity-80 px-1 rounded animate-pulse">
            <IconMic />
            <span className="text-[10px] text-white font-bold uppercase">
              Unstable
            </span>
          </div>
        )}
      </div>
      <MutedOverlay isAudioEnabled={audioEnabled} />
      {(localPeerMetadata.isHandRaised ||
        localPeerMetadata.feeling ||
        correctnessEmoji ||
        selectedAns) && (
        <div className="absolute object-cover top-1 right-1 py-1 px-2 bg-brij-Black bg-opacity-50 rounded-xl text-heading1">
          {localPeerMetadata.isHandRaised ? "✋" : ""}
          {localPeerMetadata.feeling}
          {correctnessEmoji}
          {selectedAns}
        </div>
      )}
    </div>
  );
});

// interface OtherInfoOverlayProps {
//   isHandRaised?: boolean;
//   emotion?: string;
//   correctnessEmoji?: string;
//   selectedAns: EngagementPanelResultString;
// }

// function OtherInfoOverlay({
//   isHandRaised,
//   emotion,
//   correctnessEmoji,
//   selectedAns,
// }: OtherInfoOverlayProps) {

//   if (!isHandRaised && !emotion &&)
// }

function MutedOverlay({ isAudioEnabled }: { isAudioEnabled: boolean }) {
  if (isAudioEnabled) return <></>;

  return (
    <div className="absolute object-cover top-1 left-1 py-1 px-2 bg-brij-Black bg-opacity-50 rounded-xl">
      <div className="h-[42px] w-[42px] drop-shadow-lg fill-brij-White bg-brij-Orange rounded-2xl p-2">
        <div className="absolute inset-0 grid place-items-center">
          <div className="bg-brij-White h-0.5 w-8 rotate-45" />
        </div>
        <IconMic />
      </div>
    </div>
  );
}

function Video({
  videoTrack,
  isDegraded,
}: {
  videoTrack?: string;
  isDegraded?: boolean;
}) {
  return (
    <div className="relative w-full h-full flex items-center justify-center">
      <VideoElement videoTrack={videoTrack} />
      {isDegraded && (
        <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-20 pointer-events-none">
          <div className="w-8 h-8 border-2 border-brij-Peach border-t-transparent rounded-full animate-spin mb-2" />
        </div>
      )}
    </div>
  );
}

const VideoElement = memo(({ videoTrack }: { videoTrack?: string }) => {
  const { videoRef } = useVideo({
    trackId: videoTrack,
  });

  return (
    <video
      className="relative drop-shadow-xl max-w-full max-h-full object-contain"
      ref={videoRef}
      autoPlay
      muted
      playsInline
    />
  );
});
